<div class="login-box">
  <div class="login-logo">
    <app-logo [hide]='"mini"'></app-logo>
  </div>
  <div class="card">
    <div class="card-body login-card-body">
      <h3 class="recovery-title">{{ translate.instant('PAGES.ktidentityReset.title') }}</h3>

      <div *ngIf="done" class="alert alert-success" role="status">
        {{ translate.instant('PAGES.ktidentityReset.success') }}
      </div>

      <form *ngIf="!done" #formReset="ngForm" (ngSubmit)="submit()">
        <p class="login-box-msg">{{ translate.instant('PAGES.ktidentityReset.instructions') }}</p>

        <div class="form-group">
          <label for="passwd" class="visually-hidden">{{ translate.instant('PAGES.newPasswordPlaceholder') }}</label>
          <app-password-input id="passwd" name="passwd" [placeholder]="translate.instant('PAGES.newPasswordPlaceholder')"
            autocomplete="new-password" required [(ngModel)]="password" (ngModelChange)="onPasswordChange($event)"></app-password-input>
          <app-password-strength-checklist [flags]="passwordFlags"></app-password-strength-checklist>
        </div>

        <div class="form-group">
          <label for="confirm" class="visually-hidden">{{ translate.instant('PAGES.ktidentityReset.confirmPlaceholder') }}</label>
          <app-password-input id="confirm" name="confirm" [placeholder]="translate.instant('PAGES.ktidentityReset.confirmPlaceholder')"
            autocomplete="new-password" required [(ngModel)]="confirmation"></app-password-input>
          <div *ngIf="confirmation && !passwordsMatch" class="alert alert-danger" role="alert">
            {{ translate.instant('PAGES.ktidentityReset.passwordsDoNotMatch') }}
          </div>
        </div>

        <div *ngIf="errorKey" class="alert alert-danger" role="alert">
          {{ translate.instant(errorKey) }}
          <a *ngIf="errorKey === 'PAGES.ktidentityReset.invalidLink'" routerLink="/pages/recovery"
            [queryParams]="{ provider: 'ktidentity' }">{{ translate.instant('PAGES.ktidentityReset.requestNewLink') }}</a>
        </div>

        <div class="row">
          <div class="col-6">
            <button type="submit" class="btn btn-primary btn-block btn-flat" [disabled]="!canSubmit">
              {{ translate.instant('PAGES.ktidentityReset.save') }}
            </button>
          </div>
          <div class="col-6 text-end">
            <a routerLink="/login" class="btn btn-link">{{ translate.instant('PAGES.ktidentityReset.backToLogin') }}</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
